import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Highcharts from "highcharts";
import Maps from "highcharts/modules/map";
import HighchartsVue from "highcharts-vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

Vue.use(VueMaterial);

Maps(Highcharts);

Vue.use(HighchartsVue);

//Add simple analytics to the vue prototype
Vue.prototype.SimpleAnalytics = {
  sa_event: window.sa_event,
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
